module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('colorado-map', {
    attrs: {
      "mapFile": "co.counties.json",
      "dataFile": "co_load.csv",
      "res": "Vallecito",
      "resFile": "co.json",
      "whichState": "CO"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "CO"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "co.counties.json",
      "centersFile": "co_centers.json",
      "dataFile": "co-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d185e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Colorado.vue
// module id = 368
// module chunks = 1